import {Form, message, Modal, ModalProps, TreeSelect} from 'antd';
import React, {useState} from 'react';
import {ArticleList, saveArticleTag} from '../../service';
import {GetTagList, getTags} from '../../../WebTag/service';
import {useMutation, useQuery} from 'react-query';
import {useForm} from 'antd/es/form/Form';
import ListItem from '../ListItem';

interface Props extends ModalProps {
    onOk: () => void;
    data: ArticleList;
}

const Index = ({onOk, data, ...props}: Props) => {
    const [form] = useForm();
    const [query] = useState<GetTagList>({
        content: '',
        typeId: '',
    });
    const treeOptions = useQuery({
        queryKey: ['getTags', query],
        queryFn: () => getTags(query),
    });

    const onSave = useMutation({
        mutationFn: saveArticleTag,
        onSuccess: () => {
            message.success('成功!');
            onOk?.();
        },
    });

    function onFinish(formData: {tag: string[]}) {
        onSave?.mutate({
            id: data?.id,
            tagList: formData?.tag?.join(','),
        });
    }
    return (
        <Modal {...props} width={1000} title="修改标签" onOk={form.submit}>
            <ListItem data={data} />
            <Form
                style={{marginTop: 15}}
                form={form}
                initialValues={{tag: data?.tags?.map(item => item.id)}}
                labelCol={{span: 2}}
                onFinish={onFinish}>
                {treeOptions?.data && (
                    <Form.Item name="tag" label="标签">
                        <TreeSelect
                            treeData={treeOptions?.data}
                            treeCheckable
                        />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default Index;
